import { IVehicleType } from '@cbgms/api'
import { GridCellParams, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid-pro'
import { GridHeaderFilterSingleSelect } from './GridHeaderFilterSingleSelect'
import { FilterOption } from './types.d'

export const GridOperatorIncludes = (props: { options: FilterOption[] }): GridFilterOperator[] => [
  {
    label: 'is',
    value: 'is',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null
      }

      return (params: GridCellParams<IVehicleType, string>): boolean => !!params.value?.includes(filterItem.value)
    },
    InputComponent: GridHeaderFilterSingleSelect,
    InputComponentProps: props
  }
]
